import { render, staticRenderFns } from "./ActionPostbackScenario.vue?vue&type=template&id=8bc5e122&scoped=true&"
import script from "./ActionPostbackScenario.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackScenario.vue?vue&type=script&lang=js&"
import style0 from "./ActionPostbackScenario.vue?vue&type=style&index=0&id=8bc5e122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc5e122",
  null
  
)

export default component.exports